import { render, staticRenderFns } from "./CompTableSwitch.vue?vue&type=template&id=c08d4260&scoped=true"
import script from "./CompTableSwitch.vue?vue&type=script&lang=js"
export * from "./CompTableSwitch.vue?vue&type=script&lang=js"
import style0 from "./CompTableSwitch.vue?vue&type=style&index=0&id=c08d4260&prod&scoped=true&lang=css"
import style1 from "./CompTableSwitch.vue?vue&type=style&index=1&id=c08d4260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d4260",
  null
  
)

export default component.exports